import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import Flex from '../../Flex/index.esm.js';
import Text from '../../Text/index.esm.js';
import { set, format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import { useDateInput } from 'react-nice-dates';
import TextInput from '../../TextInput/index.esm.js';

var PickerTime = function PickerTime(_ref) {
  var date = _ref.date,
      setDate = _ref.setDate,
      size = _ref.size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Date' : _ref$label,
      validate = _ref.validate;
  var timeInputProps = useDateInput({
    date: date || undefined,
    format: 'HH:mm',
    locale: enGB,
    onDateChange: function onDateChange(newDate) {
      if (newDate) {
        setDate(newDate);
      } else if (date) {
        setDate(set(date, {
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        }));
      } else {
        setDate(null);
      }
    },
    validate: validate
  });
  return React__default.createElement(Flex, {
    flexDirection: "flex-col",
    gap: "gap-y-1"
  }, React__default.createElement(Text, {
    width: "w-full",
    opacity: "opacity-50",
    fontSize: "text-sm"
  }, label), React__default.createElement(Flex, {
    gap: "gap-x-2",
    alignItems: "items-baseline"
  }, React__default.createElement(Text, {
    fontSize: size === 'sm' ? 'text-2xl' : 'text-3xl',
    textColor: "text-blue-500",
    style: {
      width: '2ch'
    }
  }, date ? format(date, 'dd') : '-'), React__default.createElement(Text, {
    fontSize: size === 'sm' ? 'text-sm' : 'text-base'
  }, date ? format(date, 'MMM yyyy') : '')), React__default.createElement(TextInput, _extends({}, timeInputProps, {
    width: "w-full",
    letterSpacing: "tracking-widest",
    maxLength: 5,
    disabled: !date,
    size: size
  })));
};

export default PickerTime;
//# sourceMappingURL=PickerTime.esm.js.map
